import { useContext } from "react";
import { z as DocContext, V as hasNavigationModifier } from "./doenetml-NmXDuMHr.js";
import { e as exceededDragThreshold } from "./dragThreshold-DuSSFrIU.js";
function useSourceNavigation(domId) {
  const { reportGraphElementUp } = useContext(DocContext);
  return reportGraphElementUp ? { domId, report: reportGraphElementUp } : void 0;
}
function attachLineFamilyDragHandlers(config) {
  const {
    jxg,
    tag,
    dragState,
    coordination,
    componentIdx,
    callAction,
    fixedRef,
    shouldDispatchFocusOnDown,
    actions,
    snapshot,
    buildTransientMoveArgs,
    buildCommitMoveArgs,
    dispatchTransientBelowThreshold,
    onDragApplied,
    suppressClickWhenDownOnOtherTag,
    suppressFocusOnDownWhenDownOnOtherTag,
    sourceNavigation,
    participatesInDownTag = true,
    clickPreludeGate,
    onDownExtra,
    onUpExtra,
    onHitExtra,
    onKeyFocusOutExtra
  } = config;
  const focusArgs = { componentIdx };
  let currentSnapshot = null;
  function reportNavigationClick(e) {
    if (!hasNavigationModifier(e)) {
      return;
    }
    sourceNavigation?.report(
      sourceNavigation.domId,
      jxg.board?.container
    );
  }
  function dispatchFocus() {
    if (actions.focus) {
      callAction({ action: actions.focus, args: focusArgs });
    }
  }
  function dispatchClick() {
    if (!actions.click) {
      return;
    }
    const preludeOk = clickPreludeGate ? clickPreludeGate.current : true;
    if (actions.clickPrelude && preludeOk) {
      callAction({ action: actions.clickPrelude });
    }
    callAction({ action: actions.click, args: focusArgs });
  }
  function dispatchCommit(variant) {
    if (!actions.move) {
      return;
    }
    const args = buildCommitMoveArgs(currentSnapshot, variant);
    if (!args) {
      return;
    }
    callAction({ action: actions.move, args });
  }
  jxg.on("down", function(e) {
    document.activeElement?.blur();
    coordination.draggedTag.current = null;
    dragState.pointerAtDown.current = [e.x, e.y];
    if (participatesInDownTag) {
      coordination.downOnTag.current = tag;
    }
    currentSnapshot = snapshot();
    dragState.pointerIsDown.current = true;
    dragState.pointerMovedSinceDown.current = false;
    const focusGate = shouldDispatchFocusOnDown ? shouldDispatchFocusOnDown() : !fixedRef.current;
    const focusSuppressed = suppressFocusOnDownWhenDownOnOtherTag && coordination.downOnTag.current !== null && coordination.downOnTag.current !== tag;
    if (focusGate && !focusSuppressed) {
      dispatchFocus();
    }
    onDownExtra?.(e);
  });
  jxg.on("hit", function(_e) {
    coordination.draggedTag.current = null;
    currentSnapshot = snapshot();
    dispatchFocus();
    onHitExtra?.();
  });
  jxg.on("drag", function(e) {
    const aboveThreshold = exceededDragThreshold(
      e,
      dragState.pointerAtDown.current
    );
    if (aboveThreshold) {
      coordination.draggedTag.current = tag;
    }
    if (aboveThreshold || dispatchTransientBelowThreshold) {
      const args = buildTransientMoveArgs(e, currentSnapshot);
      if (args && actions.move) {
        callAction({ action: actions.move, args });
      }
    }
    onDragApplied?.(currentSnapshot, e);
  });
  jxg.on("up", function(e) {
    if (coordination.draggedTag.current === tag) {
      dispatchCommit("up");
      coordination.draggedTag.current = null;
      sourceNavigation?.report(null);
    } else if (!dragState.pointerMovedSinceDown.current && !(suppressClickWhenDownOnOtherTag && coordination.downOnTag.current !== null && coordination.downOnTag.current !== tag)) {
      reportNavigationClick(e);
      if (!fixedRef.current) {
        dispatchClick();
      }
    }
    if (coordination.downOnTag.current === tag) {
      coordination.downOnTag.current = null;
    }
    dragState.pointerIsDown.current = false;
    onUpExtra?.();
  });
  jxg.on("keyfocusout", function(_e) {
    onKeyFocusOutExtra?.();
    if (coordination.draggedTag.current === tag) {
      dispatchCommit("keyFocusOut");
    }
    coordination.draggedTag.current = null;
  });
  jxg.on("keydown", function(e) {
    if (e.key !== "Enter") {
      return;
    }
    if (coordination.draggedTag.current === tag) {
      dispatchCommit("keyEnter");
      coordination.draggedTag.current = null;
    }
    reportNavigationClick(e);
    dispatchClick();
  });
}
export {
  attachLineFamilyDragHandlers as a,
  useSourceNavigation as u
};
